import * as React from 'react';
import { ImageField, ReferenceField, Show, ShowProps, SimpleShowLayout, TextField, UrlField } from 'react-admin';

export const ProductShow = (props: ShowProps): React.ReactElement => {
	return (
		<Show {...props}>
			<SimpleShowLayout>
				<TextField source="id" label="#"/>
				<ImageField source="featuredImageUrl" label="FEATURED_IMAGE"/>
				<TextField source="name" label="NAME"/>
				{/*<PriceField source="price" label="PRICE"/>*/}
				<TextField source="description" label="DESCRIPTION"/>
				<ReferenceField source="categoryId" reference="product-categories" label="CATEGORY">
					<TextField source="name"/>
				</ReferenceField>

				<UrlField source="link" label="LINK"/>
				{/*<UrlField source="videoUrl" label="VIDEO_LINK"/>*/}
			</SimpleShowLayout>
		</Show>
	);
};
